<div class="verticalFlex background align-items-center justify-content-center">
  <div style="width:300px" class="panel d-flex flex-column align-items-center justify-content-center text-center">
    <h1 class="errorCode">404</h1>
    <h2 class="errorTitle">Page Not Found</h2>
    <p class="errorMessage">The page you're looking for doesn't exist or has been moved.</p>
  </div>
  <app-footer></app-footer>
</div>
